import React from 'react';
import PropTypes from 'prop-types';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import '../UtilityView.css';

class KsDmvDetailedRenewal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { renewal, } = this.props;

    const renewalItems = VerticalLabelList.toList({
      'Registration Expiration Date': renewal.regExpDate,
      'Registration Bg Date': renewal.regBgDate,
      'Created At': renewal.createdOn,
      'Registration County Id': renewal.vehicleRegCountyId,
      'Registration PIN': renewal.registrationPin,
      Eligibility: renewal.eligibility,
      'Park Permit': renewal.parkPermit,
      'Customer Email': renewal.emailAddress,
      'Customer Id': renewal.customerId,
    });

    const vehicleItems = VerticalLabelList.toList({
      'Plate Number': renewal.plateNumber,
      'Plate Type': renewal.plateType,
      Year: renewal.year,
      Make: renewal.make,
      'Vehicle Style': renewal.vehicleStyle,
      'Vehicle Type': renewal.vehicleType,
      VIN: renewal.vin,
      'Insurance Company': renewal.insuranceCompany,
      'Policy Expiration Date': renewal.policyExpDate,
    });

    const ownerItems = VerticalLabelList.toList({
      'Organization Name': renewal.organizationName,
      'First Name': renewal.firstName,
      'Middle Name': renewal.middleName,
      'Last Name': renewal.lastName,
      'Phone Number': renewal.phoneNumber,
      Address: renewal.address,
      City: renewal.city,
      State: renewal.state,
      Zip: renewal.zip,
      County: renewal.county,
    });

    const transactionItems = VerticalLabelList.toList({
      'Transaction Id': renewal.transactionId,
      Timestamp: renewal.timestamp,
      'Property Fee': renewal.propertyFee,
      'Registration Fee': renewal.registrationFee,
      'Special Fee': renewal.specialFee,
      'ACH Failure': renewal.achFailure,
      Refunded: renewal.refunded,
      'Line Item Id': renewal.lineItemId,
    });

    return (
      <div>
        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="Renewal Summary">
            <VerticalLabelList
              items={renewalItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Vehicle Information">
            <VerticalLabelList
              items={vehicleItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Owner Information">
            <VerticalLabelList
              items={ownerItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Transaction Information">
            <VerticalLabelList
              items={transactionItems}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

KsDmvDetailedRenewal.propTypes = {
  renewal: PropTypes.instanceOf(Object).isRequired,
};

export default KsDmvDetailedRenewal;
